module.exports = __webpack_public_path__ + "images/72c92d79b9c0088382d2745da34a4367.png";